exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".overdrawnAccountNotice{margin-top:2rem;margin-bottom:2rem}.overdrawnAccountNotice .noticeBox{position:relative;border:1px dashed #c31030;border-radius:5px;padding:12px 5px}.overdrawnAccountNotice .actionOptions,.overdrawnAccountNotice .statusDescription{display:inline-block;vertical-align:top}.overdrawnAccountNotice .statusDescription{width:52%;margin-left:2.5%;margin-right:3.5%}.overdrawnAccountNotice .actionOptions{width:40%}.overdrawnAccountNotice .verticalDivider{height:20px;border-color:#ddd;margin-left:5px;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/upgrade/overdrawn_account_notice.scss
// module id = 1452
// module chunks = 0